import { render, staticRenderFns } from "./text-item.vue?vue&type=template&id=b761207c&scoped=true&"
import script from "./text-item.vue?vue&type=script&lang=js&"
export * from "./text-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b761207c",
  null
  
)

export default component.exports